import React from 'react';

import { token } from '@atlaskit/tokens';
import { css, cssMap } from '@atlaskit/css';

const styles = cssMap({
	avatarItem: {
		display: 'flex',
		alignItems: 'center',
		borderStyle: 'solid',
		borderWidth: token('border.width.selected'),
		borderColor: 'transparent',
		borderRadius: token('radius.small'),
		marginBottom: token('space.200'),
		padding: token('space.100'),
	},
	avatarItemTextWrapper: {
		maxWidth: '100%',
		flex: '1 1 100%',
		paddingInlineStart: token('space.100'),
	},
});

const placeholderTitleStyles = css({
	height: '16px',
	width: '55%',
	backgroundColor: token('color.skeleton'),
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
});

const placeholderDescriptionStyles = css({
	marginTop: token('space.050'),
	height: '32px',
	backgroundColor: token('color.skeleton'),
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
});

// Using AVATAR_SIZES here was causing a compiled issue for whatever reason
const defaultIconStyles = css({
	height: '32px',
	width: '32px',
	paddingTop: token('space.050'),
	textAlign: 'center',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	backgroundColor: token('color.skeleton'),
});

export const LoadingTemplateCard = () => (
	<div css={styles.avatarItem} data-testid="template-card-wrapper">
		<div css={defaultIconStyles} data-testid="template-card-default-icon" />
		<div css={styles.avatarItemTextWrapper}>
			<div css={placeholderTitleStyles} />
			<div css={placeholderDescriptionStyles} />
		</div>
	</div>
);
